
import Vue from "vue";
import { Settings } from "@/Settings/Settings";
import { mapState } from "vuex";
import routerManager from "@/routerManager";
import routerManagerNew from "@/routerManagerNew/routerManager";
import PartnerSettings from "@/models/PartnerSettings";
import StoreSettings from "@/models/StoreSettings";
import Product from "@/models/Product";
import { EProductOfferingType } from "@/enums/EProductOfferingType";
import StoreService from "@/services/storeService";

export default Vue.extend({
  data: () => ({
    partnerName: Settings.partner_name,
  }),

  props: ["pageTitle", "isBackBtnDisplayed"],

  computed: {
    ...mapState("store", ["selectedStoreDetails"]),
    ...mapState("ui", ["isMobileViewDisplayed"]),
    ...mapState("partner", ["partnerSettings"]),
    ...mapState("product", ["currentSelectedItem"]),

    isServiceStore(): boolean {
      return (this.selectedStoreDetails as StoreSettings).productOfferingType == EProductOfferingType.Service;
    },

    getGoBackRoute(): any {
      if(this.$route.name === "OrderSummaryPage") {
        return {name: 'OrdersPage'};
      }
      else if(typeof (this as any).selectedStoreDetails.id == "undefined") {
        return {name: 'storesPage'};
      }
      else {
        return {
          name: 'storeHomePage', 
          params: {
            storeId: (this as any).selectedStoreDetails.id,
            storeDisplayName: (this as any).selectedStoreDetails.displayName.replaceAll(' ', '-').toLocaleLowerCase()
          }
        }
      }
    }
  },

  methods: {
    goBack() {
      if (this.$route.name === "DynamicFooterPage") {
        this.$router.go(-1);
      }
      else if (this.$route.name === "OrderSummaryPage") {
        this.$router.push({name: 'OrdersPage'});
      }
      // service stores have no meaningful home page (it's skipped entirely) — the item page is effectively home.
      // Reuse the already-fetched item and do a single plain navigation (no stores-list detour, no re-fetch) —
      // that detour exists only for the initial "select a store" redirect, not for returning to an item we
      // already visited, and re-running it here was leaving the page title stuck on the page we left.
      else if (this.isServiceStore == true) {
        var storeDetails = this.selectedStoreDetails as StoreSettings;
        var cachedItem = this.currentSelectedItem as Product;

        if(cachedItem != null && cachedItem.id > 0) {
          routerManagerNew.goToProductDetailsPage(storeDetails, cachedItem);
        }

        else {
          StoreService.navigateToStoreOrServiceItem(storeDetails);
        }
      }
      else {
        routerManager.goToStoreHomePage()
      }
    }
  },
});
